module.exports = __webpack_public_path__ + "img/news7.7d85409f.png";